// Enterキーによるフォームの送信を防止する

import { closest } from './domClosest'

document.addEventListener('keypress', event => {
	const form = closest('.js-form-suppress-submit', event.target)
	if (!form) return

	const input = closest('input', event.target)
	if (!input || input.getAttribute('type') === 'submit') return

	if (event.keyCode === 13) {
		event.preventDefault();
	}
});
